export function buildDealershipApplicationsListTableHeaders({ t, showUtmColumns = false }) {
  const headers = [
    {
      value: "id",
      text: t("page.users.id"),
      thClass: "w-24",
      tdClass: "max-w-[2rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "createdAt",
      text: t("label.created"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[8rem] min-w-[8rem]",
    },
    {
      value: "companyData",
      text: t("label.companyData"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "userData",
      text: t("label.userData"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "region",
      text: t("label.region"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "processingManager",
      text: t("label.manager"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];

  if (showUtmColumns) {
    headers.push(
      {
        value: "campaign",
        text: t("label.campaign"),
        thClass: "w-[5rem]",
        tdClass: "max-w-[12rem] min-w-[9rem]",
      },
      {
        value: "medium",
        text: t("label.medium"),
        thClass: "w-[5rem]",
        tdClass: "max-w-[12rem] min-w-[9rem]",
      },
      {
        value: "source",
        text: t("label.source"),
        thClass: "w-[5rem]",
        tdClass: "max-w-[12rem] min-w-[9rem]",
      }
    );
  }

  headers.push(
    {
      value: "managerDeadline",
      text: t("label.managerDeadline"),
      thClass: "w-[13rem]",
      tdClass: "max-w-[13rem] min-w-[13rem]",
    },
    {
      value: "status",
      text: t("page.fleaMarket.status"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[13rem] min-w-[7rem]",
    }
  );

  return headers;
}
